import { io } from 'socket.io-client'

/**
 * @class DotoSocket
 *
 * @description ez az osztaly felelos a socket mukodeseert
 */
export default class DotoSocket {
  /**
   * @description konstruktor fv
   * @param socketUrl
   * @param path
   */
  constructor(socketUrl, path = null) {
    this.socketUrl = socketUrl
    this.path = path
  }

  /**
   * @description kapcsolodas a socket serverhez
   * @param params
   */
  connect(params) {
    if (typeof io === typeof undefined) return

    this.socket = io(this.socketUrl, {
      transports: ['websocket'],
      path: this.path,
      secure: this.socketUrl.indexOf('wss') === 0 ? 'true' : 'false',
      query: params,
    })

    this.socket.on('connect_error', (err) => {
      console.error('Socket connection error: ', err)
    })

    return this.socket
  }

  /**
   * @description feliratkozas esemenyre
   * @param name
   * @param handler
   * @returns {Socket<DefaultEventsMap, ListenEvents>}
   */
  addEventListener(name, handler) {
    return this.socket.on(name, function () {
      handler.apply(null, arguments)
    })
  }

  /**
   * @description esemeny kivaltasa
   * @param name
   * @param data
   * @returns {Socket<DefaultEventsMap, ListenEvents>}
   */
  emit(name, data) {
    return this.socket.emit(name, data)
  }
}
